const AUTHOR_IMAGE_SIZE = 48
const AUTHOR_IMAGE_SIZE_PX = '48'
const AUTHOR_IMAGE_RATIO = '1_1'

const getUrlProps = (url: string) => {
  return {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer',
  }
}

export {
  AUTHOR_IMAGE_SIZE,
  AUTHOR_IMAGE_SIZE_PX,
  AUTHOR_IMAGE_RATIO,
  getUrlProps,
}
